import { OneService } from 'src/cqrs/client';
import type { TransportMode } from 'src/cqrs/client';
import config from '~constants/config';

/**
 * The single, shared OneService instance for this tab. Using one instance means
 * one SignalR connection and one push stream per tab (and, once multi-tab
 * leader-election lands, one per user). The transport preference is read live
 * from the persisted options slice on every request.
 *
 * Import this instead of `new OneService(...)` anywhere in the app.
 */

// The transport-mode getter is injected from store setup rather than importing
// the store here — a static `oneService -> store` import would close a cycle
// (store -> commonSlice -> thunks -> providers -> oneService) that breaks HMR.
// Mirrors the existing `connectApiToStore` pattern.
let getTransportMode: () => TransportMode = () => 'auto';

export function connectOneServiceToStore(getter: () => TransportMode): void {
  getTransportMode = getter;
}

export const oneService = new OneService({
  baseUrl: config.API_URL,
  // Graph SignalR hub. The generic-graph Query/Command/Push are served on the
  // same SignalR hub as the legacy device events — `${API_URL}/hub/v1` — NOT a
  // separate `/hub/graph` path (which 404s). Derived from the single API URL;
  // there is no separate SignalR env var.
  graphHubUrl: `${config.API_URL}/hub/v1`,
  getTransportMode: () => getTransportMode(),
});
